'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeBroadenSearchEvent = composeBroadenSearchEvent;
exports.composeEmptySearchResultsEvent = composeEmptySearchResultsEvent;
exports.composeSearchResultsEvent = composeSearchResultsEvent;
exports.composeDidYouMeanClickEvent = composeDidYouMeanClickEvent;
exports.composeModifySearchClickEvent = composeModifySearchClickEvent;
exports.composeExternalSearchClickEvent = composeExternalSearchClickEvent;
exports.composeOtherResourcesClickEvent = composeOtherResourcesClickEvent;
exports.composeDidNotFindPanelToggleEvent = composeDidNotFindPanelToggleEvent;
exports.composeChatWithLibrarianClickEvent = composeChatWithLibrarianClickEvent;
exports.composeDidNotFindResourceClickEvent = composeDidNotFindResourceClickEvent;
exports.composeDidNotFindServiceClickEvent = composeDidNotFindServiceClickEvent;
exports.composeDidNotFindMoreResourcesClickEvent = composeDidNotFindMoreResourcesClickEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS,
    LABELS = _constantsAnalytics2.default.LABELS;


function composeSearchEvent(_ref) {
  var event = _ref.event,
      _ref$gtmCategory = _ref.gtmCategory,
      gtmCategory = _ref$gtmCategory === undefined ? CATEGORIES.SEARCH : _ref$gtmCategory,
      gtmAction = _ref.gtmAction,
      _ref$gtmValue = _ref.gtmValue,
      gtmValue = _ref$gtmValue === undefined ? 1 : _ref$gtmValue,
      gtmLabel = _ref.gtmLabel,
      payload = _objectWithoutProperties(_ref, ['event', 'gtmCategory', 'gtmAction', 'gtmValue', 'gtmLabel']);

  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(event, _extends({
    gtmCategory: gtmCategory,
    gtmAction: gtmAction,
    gtmValue: gtmValue,
    gtmLabel: gtmLabel
  }, payload))]);
}

function composeBroadenSearchEvent(_ref2) {
  var query = _ref2.query,
      searchType = _ref2.searchType;

  return composeSearchEvent({
    event: EVENTS.BROADEN_SEARCH,
    gtmAction: ACTIONS.BROADEN,
    gtmLabel: query,
    searchType: searchType
  });
}

function composeEmptySearchResultsEvent(_ref3) {
  var query = _ref3.query,
      searchType = _ref3.searchType,
      didYouMeanQuerySuggestion = _ref3.didYouMeanQuerySuggestion;

  return composeSearchEvent({
    gtmCategory: CATEGORIES.EMPTY_SEARCH_RESULTS,
    event: EVENTS.EMPTY_SEARCH_RESULT,
    gtmAction: didYouMeanQuerySuggestion ? ACTIONS.RESULT_DID_YOU_MEAN : ACTIONS.RESULT,
    gtmLabel: didYouMeanQuerySuggestion ? didYouMeanQuerySuggestion + ' | ' + query : query,
    searchType: searchType
  });
}

function composeSearchResultsEvent(_ref4) {
  var query = _ref4.query,
      searchType = _ref4.searchType;

  return composeSearchEvent({
    event: EVENTS.SEARCH_RESULTS,
    gtmAction: ACTIONS.RESULT,
    gtmLabel: query,
    searchType: searchType
  });
}

function composeDidYouMeanClickEvent(_ref5) {
  var query = _ref5.query,
      suggestion = _ref5.suggestion,
      emptySearch = _ref5.emptySearch;

  return composeSearchEvent({
    event: EVENTS.DYM_SEARCH_RESULT_CLICK,
    gtmCategory: emptySearch ? CATEGORIES.EMPTY_SEARCH_RESULTS : CATEGORIES.SEARCH,
    gtmAction: ACTIONS.CLICK_LINK,
    gtmLabel: suggestion + ' | ' + query,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.SEARCH_TITLE
  });
}

function composeModifySearchClickEvent() {
  return composeSearchEvent({
    event: EVENTS.MODIFY_SEARCH_CLICK,
    gtmAction: ACTIONS.CLICK_LINK,
    gtmLabel: LABELS.MODIFY_MY_SEARCH,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.SEARCH_TITLE
  });
}

function composeExternalSearchClickEvent(_ref6) {
  var emptySearch = _ref6.emptySearch,
      outboundURL = _ref6.outboundURL;

  return composeSearchEvent({
    event: EVENTS.EXTERNAL_SEARCH_CLICK,
    gtmCategory: emptySearch ? CATEGORIES.EMPTY_SEARCH_RESULTS : CATEGORIES.SEARCH,
    gtmAction: ACTIONS.OUTBOUND_LINK_CLICK,
    gtmLabel: outboundURL,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.SEARCH_TITLE
  });
}

function composeOtherResourcesClickEvent(_ref7) {
  var emptySearch = _ref7.emptySearch,
      label = _ref7.label,
      outboundURL = _ref7.outboundURL;

  return (0, _compose.composeAnalytics)([(0, _compose.composeLinkEvent)(EVENTS.SEARCH_OTHER_RESOURCES_CLICK, outboundURL, {
    gtmCategory: emptySearch ? CATEGORIES.EMPTY_SEARCH_RESULTS : CATEGORIES.SEARCH,
    gtmValue: 1,
    gtmLabel: label,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.SEARCH_TITLE,
    gtmContentType: CUSTOM_DIMENSIONS.CONTENT_TYPES.ONLINE_RESOURCE
  })]);
}

function composeDidNotFindPanelToggleEvent(_ref8) {
  var expanded = _ref8.expanded;

  return composeSearchEvent({
    event: EVENTS.DID_NOT_FIND_PANEL_TOGGLE,
    gtmCategory: CATEGORIES.SEARCH_DID_NOT_FIND,
    gtmAction: ACTIONS.INTERACT_WITH_CONTAINER,
    gtmLabel: expanded ? LABELS.CONTAINER_EXPAND : LABELS.CONTAINER_COLLAPSE,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.DID_NOT_FIND_PANEL
  });
}

function composeChatWithLibrarianClickEvent() {
  return composeSearchEvent({
    event: EVENTS.CHAT_WITH_LIBRARIAN_CLICK,
    gtmCategory: CATEGORIES.SEARCH_DID_NOT_FIND,
    gtmAction: ACTIONS.CLICK_LINK,
    gtmLabel: LABELS.CHAT_WITH_LIBRARIAN,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.DID_NOT_FIND_PANEL
  });
}

function composeDidNotFindResourceClickEvent(_ref9) {
  var text = _ref9.text,
      url = _ref9.url,
      emptySearch = _ref9.emptySearch;

  return (0, _compose.composeAnalytics)([(0, _compose.composeLinkEvent)(EVENTS.DID_NOT_FIND_RESOURCE_CLICK, url, {
    gtmCategory: emptySearch ? CATEGORIES.EMPTY_SEARCH_RESULTS : CATEGORIES.SEARCH,
    gtmValue: 1,
    gtmLabel: text,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.DID_NOT_FIND_PANEL_RESOURCES
  })]);
}

function composeDidNotFindServiceClickEvent(_ref10) {
  var text = _ref10.text,
      url = _ref10.url,
      emptySearch = _ref10.emptySearch;

  return (0, _compose.composeAnalytics)([(0, _compose.composeLinkEvent)(EVENTS.DID_NOT_FIND_SERVICE_CLICK, url, {
    gtmCategory: emptySearch ? CATEGORIES.EMPTY_SEARCH_RESULTS : CATEGORIES.SEARCH,
    gtmValue: 1,
    gtmLabel: text,
    gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.DID_NOT_FIND_PANEL_SERVICES
  })]);
}

function composeDidNotFindMoreResourcesClickEvent(_ref11) {
  var url = _ref11.url,
      emptySearch = _ref11.emptySearch;

  return (0, _compose.composeAnalytics)([(0, _compose.composeLinkEvent)(EVENTS.DID_NOT_FIND_MORE_RESOURCES_CLICK, url, {
    gtmCategory: emptySearch ? CATEGORIES.EMPTY_SEARCH_RESULTS : CATEGORIES.SEARCH,
    gtmValue: 1,
    gtmLabel: LABELS.VIEW_MORE_RESOURCES
  })]);
}

exports.default = {
  composeBroadenSearchEvent: composeBroadenSearchEvent,
  composeEmptySearchResultsEvent: composeEmptySearchResultsEvent,
  composeSearchResultsEvent: composeSearchResultsEvent,
  composeDidYouMeanClickEvent: composeDidYouMeanClickEvent,
  composeModifySearchClickEvent: composeModifySearchClickEvent,
  composeExternalSearchClickEvent: composeExternalSearchClickEvent,
  composeOtherResourcesClickEvent: composeOtherResourcesClickEvent,
  composeDidNotFindPanelToggleEvent: composeDidNotFindPanelToggleEvent,
  composeChatWithLibrarianClickEvent: composeChatWithLibrarianClickEvent,
  composeDidNotFindResourceClickEvent: composeDidNotFindResourceClickEvent,
  composeDidNotFindServiceClickEvent: composeDidNotFindServiceClickEvent,
  composeDidNotFindMoreResourcesClickEvent: composeDidNotFindMoreResourcesClickEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/searchEventComposer.js
// module id = 586
// module chunks = 0 2 4 5 6 8 9 10 11